module.exports = "../../app/cells/components/intervention_bottom_bar_cell.rb";